// usage examples:
//
// import {getScrollTop} from './lib/utilities';
// or
// import * as Utils from './lib/utilities';

/**
 * Detect breakpoints - see https://adactio.com/journal/5429 for more info on usage
 * @return {String} - the value of breakpoint set in the CSS
 */
export function getBreakpoint() {
  return window
    .getComputedStyle(document.body, ':after')
    .getPropertyValue('content');
}

/**
 * Get scroll position
 * @return {Undefined}
 */
export function getScrollTop() {
  const doc = document.documentElement;
  return (window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0);
}

/**
 * Returns a function that gets triggered after a wait period
 * Useful for resize event listeners, to trigger after all resizing is done
 * @param {Function} func
 * @param {Number} wait - time to wait in milliseconds
 * @return {Function} debounced function
 */
export function debounce(func, wait = 250) {
  let timeout;
  return function(...args) {
    // eslint-disable-next-line no-invalid-this
    const context = this;
    const later = function() {
      timeout = null;
      func.apply(context, args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
}

/**
 * @param {Number} x
 * @param {Number} y
 * @return {Number}
 */
export function getDistance( x, y ) {
  return Math.sqrt( x * x + y * y );
}

/**
 * linear interpolate
 * @param {Number} a
 * @param {Number} b
 * @param {Number} alpha - value 0...1
 * @return {Number}
 */
export function lerp(a, b, alpha) {
  return a + (b - a) * alpha;
}


/**
 * get modulo, not remainder
 * @param {Number} num
 * @param {Number} div
 * @return {Number}
 */
export function modulo( num, div) {
  return ( ( num % div ) + div ) % div;
}
